import React from 'react';

const Icon = ({ width = '49', height = '48', fill = 'white', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 49 48" fill="none" {...other}>
            <path
                d="M25 3a12.6 12.6 0 0 1 12.6 12.6v16.8a12.6 12.6 0 1 1-25.2 0V15.6A12.6 12.6 0 0 1 25 3Zm0 2.8a9.8 9.8 0 0 0-9.794 9.464l-.006.336v16.8a9.8 9.8 0 0 0 19.594.336l.006-.336V15.6A9.8 9.8 0 0 0 25 5.8Zm0 21a1.4 1.4 0 1 1 0 2.799 1.4 1.4 0 0 1 0-2.799ZM25 10a7 7 0 1 1 .034 14A7 7 0 0 1 25 10Zm0 2.8a4.2 4.2 0 1 0 0 8.4 4.2 4.2 0 0 0 0-8.4Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
